const getters = {
    getPermintaanKasWorkshopList: (state) => state.permintaanKasWorkshopList,
    getPermintaanKasWorkshopDetail: (state) => state.permintaanKasWorkshopDetail,
    getPagination: (state) => state.pagination,
    getSearch: (state) => state.search,
    getIsSearch: (state) => state.isSearch,
    getQueryPermintaanWorkshopList: (state) => state.queryPermintaanWorkshopList,
    getScrollPosition: (state) => state.scrollPosition,
};

export default getters;
